import log from 'salvo-lite/log'
import objectFitImages from 'object-fit-images'

class ObjectFit {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        this._elem.addEventListener('DOMContentLoaded', () => {
            objectFitImages()
        })
    }
}

export default ObjectFit



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ObjectFit.js